/* global Papa, $charts_collection */

'use strict';

window.charts_collection = {};
window.dataset_collection = {};
window.labels_collection = {};
window.original_labels = {};

// Constructor
var Chartblock = function () {
    var $legend_box_width = 20;
    var $legend_padding = 18;
    var $legend_font_size = 16;

    // Go through each chart element on the page
    $('.csv-chart').each(function () {
        var $header; // The header row
        var $container = $(this);
        var original = Chart.defaults.global.legend.onClick; // We keep the original legend onclick
        var $chart_reference = $container.data('reference') ? $container.data('reference') : 'no-ref-' + makeid();
        var $configuration = $container.data('configuration'); // The configuration object from the data attribute
        var $type = $configuration.type ? $configuration.type : 'horizontalBar'; // Type of chart
        var $x_axis = typeof $configuration.x_axis === 'undefined' ? true : $configuration.x_axis; // Show x axis and gridlines
        var $x_axis_label_show = typeof $configuration.x_axis_label === 'undefined' ? false : true; // Show x axis label
        var $x_axis_label_text = typeof $configuration.x_axis_label === 'undefined' ? false : $configuration.x_axis_label; // Show x axis label
        var $y_axis_label_show = typeof $configuration.y_axis_label === 'undefined' ? false : true; // Show y axis label
        var $y_axis_label_text = typeof $configuration.y_axis_label === 'undefined' ? false : $configuration.y_axis_label; // Show y axis label
        var $y_axis = typeof $configuration.y_axis === 'undefined' ? true : $configuration.y_axis; // Show y axis and gridlines
        var $y_axis_leading_zero = typeof $configuration.y_axis_leading_zero === 'undefined' ? false : $configuration.y_axis_leading_zero; // Show y axis and gridlines
        var $y_axis_suffix = typeof $configuration.y_axis_suffix === 'undefined' ? false : $configuration.y_axis_suffix; // Suffix like %
        var $y_axis_is_year = typeof $configuration.y_axis_is_year === 'undefined' ? false : $configuration.y_axis_is_year; // No number format for years
        var $y_raw = typeof $configuration.y_raw === 'undefined' ? false : $configuration.y_raw; // No number format 
        var $x_axis_is_year = typeof $configuration.x_axis_is_year === 'undefined' ? false : $configuration.x_axis_is_year; // No number format for years
        var $x_axis_no_percentage = typeof $configuration.x_axis_no_percentage === 'undefined' ? false : $configuration.x_axis_no_percentage; // Prevent adding % sign at the end
        var $x_gridlines = typeof $configuration.x_gridlines === 'undefined' ? true : $configuration.x_gridlines; // Show gridlines
        var $y_gridlines = typeof $configuration.y_gridlines === 'undefined' ? true : $configuration.y_gridlines; // Show gridlines
        var $legend = typeof $configuration.legend === 'undefined' ? true : $configuration.legend; // Show or hide legend
        var $legend_position = typeof $configuration.legend_position === 'undefined' ? 'right' : $configuration.legend_position; // Show or hide legend
        var $single_color = typeof $configuration.single_color === 'undefined' ? false : $configuration.single_color; // Force a single color on chart
        var $label_font_size = typeof $configuration.label_font_size === 'undefined' ? 12 : $configuration.label_font_size; // Size of axis labels
        var $show_data_labels = typeof $configuration.show_data_labels === 'undefined' ? false : $configuration.show_data_labels; // The label end of charts
        var $padding_right = typeof $configuration.padding_right === 'undefined' ? 0 : $configuration.padding_right; //Add padding to the cavas
        var $padding_left = typeof $configuration.padding_left === 'undefined' ? 0 : $configuration.padding_left; //Add padding to the cavas
        var $bar_line_height = typeof $configuration.bar_line_height === 'undefined' ? 35 : $configuration.bar_line_height; //Add padding to the cavas
        var $tooltip_show_currency = typeof $configuration.tooltip_show_currency === 'undefined' ? false : $configuration.tooltip_show_currency; //Show currency in tooltip
        var $tooltip_show_label = typeof $configuration.tooltip_show_label === 'undefined' ? false : $configuration.tooltip_show_label; //Show currency in tooltip
        var $tooltip_overite_label = typeof $configuration.tooltip_overite_label === 'undefined' ? false : $configuration.tooltip_overite_label; //Show currency in tooltip
        var $tooltip_show_percentage = typeof $configuration.tooltip_show_percentage === 'undefined' ? false : $configuration.tooltip_show_percentage; //Show currency in tooltip
        var $tooltip_hide_value = typeof $configuration.tooltip_hide_value === 'undefined' ? false : $configuration.tooltip_hide_value; //Hide the tooltip value only show label
        var $tooltip_number_format = typeof $configuration.tooltip_number_format === 'undefined' ? false : $configuration.tooltip_number_format; //Add thousand seperators
        var $tooltip_decimal = typeof $configuration.tooltip_decimal === 'undefined' ? false : $configuration.tooltip_decimal; //Add thousand seperators
        var $disable_filter = typeof $configuration.disable_filter === 'undefined' ? false : $configuration.disable_filter; //Disable clicking on legend
        var $chart_stack = typeof $configuration.chart_stack === 'undefined' ? true : $configuration.chart_stack; //If not defined charts are stacked by default
        var $external_filter = typeof $configuration.external_filter === 'undefined' ? false : $configuration.external_filter; //If not defined charts are stacked by default
        var $max_initial_dataset = typeof $configuration.max_initial_dataset === 'undefined' ? false : $configuration.max_initial_dataset; //How many datasets to show on initial load
        var $groupped_first_col = typeof $configuration.groupped_first_col === 'undefined' ? false : $configuration.groupped_first_col; // Change how the dataset is constructed
        var $special_mix_chart = typeof $configuration.special_mix_chart === 'undefined' ? false : $configuration.special_mix_chart; // Change how the dataset is constructed
        var $always_show_value = typeof $configuration.always_show_value === 'undefined' ? false : $configuration.always_show_value; // Change how the dataset is constructed
        var $always_show_positive = typeof $configuration.always_show_positive === 'undefined' ? false : $configuration.always_show_positive; // Done for gender chart, always have positive values
        var $step_size = typeof $configuration.step_size === 'undefined' ? false : $configuration.step_size; // Done for gender chart, always have positive values

        // Pulls the CSV data in json
        Papa.parse($configuration.url, {
            download: true,
            dynamicTyping: true,
            skipEmptyLines: true,
            complete: function ($json) {

                // Process the data
                $configuration.header ? $header = $json.data.shift() : '';
                $configuration.header ? $header.shift() : '';
                $groupped_first_col ? $header.shift() : ''; // If we are using the first col on header row to group the data then skip one more col

                // Color palettes
                var $color_codes = colorCodes();

                // Create the dataset and add the colors and labels
                var $dataset = [];
                var $groups = {};
                var $labels = [];
                var $labels_groupped = [];
                var $labels_total_line = 0;
                var $max_width = 15; // Max width of label
                $type === 'doughnut' ? $max_width = 1000 : ''; // On dougnut do not split the labels messing up the legend
                $external_filter ? $legend = false : ''; // If external_filter is set then disable the legend on the canvas

                // console.log($json.data); 


                // Rearrange the dataset
                $.each($json.data, function ($index, $value) {
                    var $group = $groupped_first_col ? $value.shift() : 'Not groupped';
                    var $label = $value.shift();
                    $groups[$group.replace(/[^A-Z0-9]/ig, "_")] = $group // Collect the groups

                    $($value).each(function ($key, $number) {
                        // If this is a multi dataset or single dataset chart 

                        // Make sure the values are numbers, we ignore %
                        if (typeof $number === 'string' && $number.indexOf("%") === -1) {
                            $number = Number($number.replace(/,\s?/g, ""));
                        }

                        var $color_index = $value.length > 1 ? $key : $index; // Define which color to pick

                        // If not a doughnut and has only 1 dataset set the color to same index

                        $value.length === 1 && $type !== 'doughnut' ? $color_index = 1 : '';
                        $value.length === 1 && $type !== 'doughnut' && !$always_show_value ? $tooltip_hide_value = true : '';

                        $dataset[$key] ? '' : $dataset[$key] = { label: '', data: [], backgroundColor: [], borderColor: [] };
                        $dataset[$key]["label"] = formatLabel($header[$key], $max_width, false);
                        $dataset[$key]["data"].push(parseFloat($number));
                        $max_initial_dataset && $key > $max_initial_dataset ? $dataset[$key]["hidden"] = true : ''; // If there is a max number of initial datasets to show


                        // If this is a line chart, then no background color
                        if ($type === 'line') {
                            $dataset[$key]["borderColor"] = $single_color ? $single_color : $color_codes[$color_index];
                            $dataset[$key]["backgroundColor"] = 'rgba(255, 255, 255, 0)';
                        } else {
                            $dataset[$key]["backgroundColor"].push($single_color ? $single_color : $color_codes[$color_index]);
                        }

                        if ($special_mix_chart) {
                            if ($header[$key] === 'Patent Family') {
                                $dataset[$key]["type"] = 'line';
                                $dataset[$key]["showLine"] = false;
                                $dataset[$key]["pointBorderWidth"] = 5;
                                // $dataset[$key]["pointBackgroundColor"] = $single_color ? $single_color : $color_codes[$color_index];
                                $dataset[$key]["borderColor"] = $single_color ? $single_color : $color_codes[$color_index];
                                $dataset[$key]["pointBackgroundColor"] = '#50E3C2';
                                $dataset[$key]["borderColor"] = '#50E3C2';
                                $dataset[$key]["pointRadius"] = 4;
                                $dataset[$key]["backgroundColor"] = ['rgba(0,0,0,0)'];
                            }
                        }
                    });

                    // The first column in the row is the label for the dataset
                    $labels.push(formatLabel($label, $max_width, $y_axis_leading_zero));

                    if ($groupped_first_col) {
                        $labels_groupped.push({ group: $group, label: formatLabel($label, $max_width, $y_axis_leading_zero) });
                    }

                    // Add the size of the label array back
                    var $formatted_label = formatLabel($label, $max_width, $y_axis_leading_zero);
                    if ($formatted_label && $formatted_label.constructor === Array) {
                        $labels_total_line = $labels_total_line + $formatted_label.length;
                    } else {
                        $labels_total_line = $labels_total_line + 1;
                    }
                });



                // Clone the dataset
                var $dataset_clone = [];
                $($dataset).each(function ($index, $data) {
                    $dataset_clone.push({ data: $data.data });
                });


                // If we have groupped dataset or dataset filter then we store the original dataset to global and work with it
                $groupped_first_col ? window.dataset_collection[$chart_reference] = $dataset_clone : '';
                $groupped_first_col ? window.labels_collection[$chart_reference] = $labels_groupped : '';
                $groupped_first_col ? window.original_labels[$chart_reference] = $labels : '';



                // If browser width < 900px reposition the legend and change padding              
                if (window.innerWidth < 700) {
                    $legend_position = 'bottom';
                    $legend_padding = 15;
                    $legend_font_size = 13;
                }

                var $chart_height = $labels_total_line * 45;
                $chart_height < 600 ? $chart_height = $labels_total_line * 65 : '';
                $chart_height < 300 ? $chart_height = 300 : ''; // Make sure the chart is min 300

                // If this is not a Doughnut or Line chart type
                if ($type !== 'doughnut' && $type !== 'line' && $type !== 'bar') {
                    $container.closest('.chart-container').css('height', $chart_height); // Adjust the canvas height
                    (parseInt($chart_height / $labels.length) - 50) < 35 ? $bar_line_height = 35 : $bar_line_height = (parseInt($chart_height / $labels.length) - 50); // Set the actual bars
                    $bar_line_height > 60 ? $bar_line_height = 60 : ''; // Cap the bar height to max 60
                    $dataset.length === 1 ? $legend = false : ''; // If there is only 1 dataset then hide the legend                    
                }

                // Draw the chart
                window.charts_collection[$chart_reference] = new Chart($container[0].getContext('2d'), {
                    type: $type,
                    data: {
                        labels: $labels,
                        datasets: $dataset
                    },
                    options: {
                        responsive: true,
                        elements: {
                            line: {
                                tension: 0, // disables bezier curves
                            }
                        },
                        maintainAspectRatio: false,
                        layout: {
                            padding: {
                                left: $padding_left,
                                right: $padding_right,
                                top: 20,
                                bottom: 20
                            }
                        },
                        tooltips: {
                            mode: 'single',
                            callbacks: {
                                // this callback is used to create the tooltip label
                                label: function (tooltipItem, data) {

                                    // console.log('tooltipItem', tooltipItem);
                                    // console.log('data', data);

                                    // get the data label and data value to display
                                    // var dataLabel;
                                    // if (data.datasets.length > 1) {
                                    // } else {

                                    // }
                                    var dataLabel =
                                        data.datasets.length > 1 ?
                                            (data.datasets[tooltipItem.datasetIndex].label[0] ?
                                                data.datasets[tooltipItem.datasetIndex].label.join(' ')
                                                : data.datasets[tooltipItem.datasetIndex].label)
                                            : (data.labels[tooltipItem.index][0] ?
                                                data.labels[tooltipItem.index].join(' ')
                                                : data.labels[tooltipItem.index]);

                                    // add the currency symbol $ to the label
                                    var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

                                    // Format the value
                                    if ($x_axis_is_year) {
                                        $tooltip_number_format ? value = value.toLocaleString() : '';
                                    } else {
                                        $always_show_positive && value < 0 ? value = value * -1 : '';
                                        $tooltip_decimal ? value = Number(value).toFixed($tooltip_decimal) : '';
                                        $tooltip_number_format ? value = value.toLocaleString() : '';
                                        $tooltip_show_currency ? value = '$ ' + value : '';
                                        $tooltip_show_label ? value = $tooltip_show_label + ": " + value : '';
                                        $tooltip_show_percentage ? value = value + '%' : '';
                                    }

                                    // If forced to hide value
                                    $tooltip_hide_value ? '' : dataLabel += ': ' + value;

                                    $tooltip_overite_label ? dataLabel = value : '';

                                    // If there is 1 dataset and we are on bar chart
                                    if ((data.datasets.length === 1 && $type === "horizontalBar") || data.datasets.length === 1 && $type === "bar") {
                                        return value
                                    } else {
                                        // return the text to display on the tooltip
                                        return dataLabel;
                                    }
                                }
                            }
                        },
                        legend: {
                            display: $legend,
                            position: $legend_position,
                            labels: {
                                boxWidth: $legend_box_width,
                                padding: $legend_padding,
                                fontSize: $legend_font_size,
                                fontFamily: 'Cabin',
                                filter: function ($item, $chartdata) {
                                    if (typeof $item['text'] === 'object' && $item['text'] !== null) {
                                        $item['text'] = $item['text'].join(' '); // Remove the comma from the legend label
                                    }
                                    return $item;
                                }
                            },

                            onClick: function ($event, $item) {
                                if ($disable_filter) {
                                    $event.stopPropagation();
                                } else {
                                    original.call(this, $event, $item);
                                }
                            }
                        },
                        scales: {
                            xAxes: [{
                                display: $x_axis,
                                stacked: $chart_stack,
                                gridLines: {
                                    display: $x_gridlines
                                },
                                ticks: {
                                    fontSize: $label_font_size,
                                    fontColor: '#021A2B',
                                    fontFamily: 'Cabin',
                                    autoSkip: false,
                                    callback: function (value, index, values) {

                                        // Check the largest value in the ticks. To know what devider to use
                                        var $suffix = ' k';
                                        var $divider = 0;

                                        value[0] ? value = value.join(' ') : ''; // Remove commas on x-axis #89139

                                        if ($x_axis_is_year) {
                                            // Do not format the ticks
                                        } else {
                                            var $largest = Math.max.apply(Math, values);
                                            if ($largest >= 1000000) {
                                                $suffix = ' m';
                                                $divider = 1000000;
                                            } else if ($largest >= 1000) {
                                                $suffix = ' k';
                                                $divider = 1000;
                                            }

                                            $always_show_positive && value < 0 ? value = value * -1 : '';

                                            if ($divider > 0) {
                                                value = value / $divider;
                                                value = value.toLocaleString() + $suffix;
                                            } else {
                                                $tooltip_number_format ? value = value.toLocaleString() : '';
                                            }

                                            $tooltip_show_percentage && !$x_axis_no_percentage ? value = value + '%' : '';
                                            $tooltip_show_currency ? value = '$ ' + value : '';
                                            // $tooltip_show_label ? value = $tooltip_show_label + ": " + value : '';
                                        }

                                        return value;
                                    }
                                },
                                scaleLabel: {
                                    display: $x_axis_label_show,
                                    labelString: $x_axis_label_text,
                                    padding: 20,
                                    fontSize: 18,
                                    fontColor: '#000',
                                    fontFamily: 'Cabin',
                                    fontStyle: 'bold'
                                }
                            }],
                            yAxes: [{
                                display: $y_axis,
                                barThickness: $bar_line_height,
                                stacked: $chart_stack,
                                gridLines: {
                                    display: $y_gridlines
                                },
                                ticks: {
                                    fontSize: $label_font_size,
                                    fontColor: '#021A2B',
                                    stepSize: $step_size,
                                    fontFamily: 'Cabin',
                                    callback: function (value, index, values) {

                                        // Check the largest value in the ticks. To know what devider to use
                                        var $suffix = ' k';
                                        var $divider = 0;

                                        if ($y_axis_is_year || $y_raw) {
                                            // Do not format the ticks
                                        } else {

                                            var $largest = Math.max.apply(Math, values);
                                            if ($largest > 2300) {
                                                if ($largest >= 1000000) {
                                                    $suffix = ' m';
                                                    $divider = 1000000;
                                                } else if ($largest >= 1000) {
                                                    $suffix = ' k';
                                                    $divider = 1000;
                                                }

                                                if ($divider > 0) {
                                                    value = value / $divider;
                                                    value = value.toLocaleString() + $suffix;
                                                }
                                            }
                                        }


                                        if ($y_axis_suffix) {
                                            // Do not format the ticks
                                            value = value + $y_axis_suffix;
                                        }

                                        return value;
                                    }
                                },
                                scaleLabel: {
                                    display: $y_axis_label_show,
                                    labelString: $y_axis_label_text,
                                    padding: 20,
                                    fontSize: 18,
                                    fontColor: '#000',
                                    fontFamily: 'Cabin',
                                    fontStyle: 'bold'
                                }
                            }]
                        },
                        plugins: {
                            datalabels: {
                                display: $show_data_labels,
                                color: '#005792',
                                align: 'right',
                                offset: 20,
                                anchor: 'end',
                                font: {
                                    weight: 'bold',
                                    size: '22',
                                    family: 'Cabin'
                                },
                                formatter: function (value, context) {
                                    return value + '%';
                                }

                            }
                        },
                        animation: {
                            onComplete: function () {
                                // Get the base64 for print
                                var $image_print = this.toBase64Image();
                                $container.closest('.chart-container').find('.chart-print').remove();
                                $container.closest('.chart-container').append('<img class="chart-print" src="' + $image_print + '">');
                            }
                        }
                    }

                });


                // If external_filter is set then disable the legend and add filter box on top;
                if ($external_filter) {
                    var $filter_html = '';
                    var $legend_html = '';
                    // Go through each dataset and build the list of options
                    $(window.charts_collection[$chart_reference].data.datasets).each(function ($index, $data) {
                        var $checked = !$data.hidden ? 'checked' : '';
                        var $dataset_ref = $chart_reference + "_" + $index; // Create a reference based on the chart reference and index
                        var $color = $type === 'line' ? $data['borderColor'] : $data['backgroundColor'][0];
                        var $data_value = $data["label"][0] ? $data["label"][0] : $data["label"];
                        var $data_label = $data["label"][0] ? $data["label"].join(' ') : $data["label"];
                        // console.log($data);
                        $filter_html +=
                            "<li class='table_group_" + $chart_reference + "'>" +
                            "<input " + $checked + " type='checkbox' id='filter_" + $dataset_ref + "' data-dataset-index='" + $index + "' data-chart-target='" + $chart_reference + "'  value='" + $data_value + "'/>" +
                            "<label style='color:" + $color + "' for='filter_" + $dataset_ref + "'><span>" + $data_label + "</span></label>" +
                            "</li>";

                        if ($checked === 'checked') {
                            $legend_html += "<li><label style='color:" + $color + "' ><span>" + $data_label + "</span></label></li>";
                        }
                    });
                    var $label_text = $max_initial_dataset ? '...' : 'All';
                    $filter_html = "<div class='chart-filter chart_filter_" + $chart_reference + "'>" +
                        "<div class='right'>" +
                        "<div class='label'>View FoR</div>" +
                        "<div class='dropdown widget-container'>" +
                        "<button class='selected'>" +
                        "<span>" + $label_text + "</span>" +
                        "</button>" +
                        "<ul class='list'>" + $filter_html + "</ul>" +
                        "</div></div></div>";

                    $legend_html = "<ul class='legend_html'>" + $legend_html + "</ul>";

                    $container.closest('.chart-container').before($filter_html);
                    $container.closest('.chart-container').after($legend_html);

                    // Bind the change action to the filter checkboxes
                    $(".dropdown.widget-container .list li.table_group_" + $chart_reference + " input").change(function () {

                        // When a checkbox is ticked go through the list and build the search filter
                        var $value = '';
                        var $legend_html = "";
                        var $chart_target = $(this).data('chart-target');

                        // Disable all the datasets and enable only the active one
                        $(window.charts_collection[$chart_reference].data.datasets).each(function ($index, $value) {
                            window.charts_collection[$chart_reference].getDatasetMeta($index).hidden = true;
                        });

                        // Go through the ticked checkbox and collect the data & Enable the ticked datasets
                        $(this).closest('.dropdown.widget-container').find("input:checked").each(function () {
                            $value += ($(this).val().length > 4 ? $(this).val().substr(0, 2) : $(this).val()) + "|"
                            window.charts_collection[$chart_reference].getDatasetMeta($(this).data('dataset-index')).hidden = false;

                            $legend_html += "<li><label style='" + $(this).siblings('label').attr('style') + "' ><span>" + $(this).siblings('label').text() + "</span></label></li>";
                        })


                        // After collecting all the values check if there is anything to filter
                        if ($value) {
                            // If there a value ticked then we show only the ticked ones
                            $(this).closest('.widget-container').find('.selected span').html($value.slice(0, -1).replace(/\|/g, ", "));
                        } else {
                            // If no checkbox is ticked then show everything
                            $(this).closest('.widget-container').find('.selected span').html('All');
                            $(window.charts_collection[$chart_reference].data.datasets).each(function ($index, $value) {
                                window.charts_collection[$chart_reference].getDatasetMeta($index).hidden = false;
                            });
                        }

                        // Apply to chart
                        window.charts_collection[$chart_reference].update();


                        // Go through all the selected and build the legend list again
                        $(this).closest('.chart').find('.legend_html').html($legend_html);

                    });

                    // Bind action to expand the filter list
                    $('.chart_filter_' + $chart_reference + ' .widget-container button').click(function ($event) {
                        $event.stopPropagation()
                        !$(this).closest('.collapsible-box').hasClass('expanded') ? $(this).closest('.collapsible-box').find('.toggle').click() : '';
                        $(this).siblings('.list').toggleClass('active');
                        $(this).toggleClass('active');
                    })

                    // Clicking on the open filer dropdown. Stop propagation
                    $('.chart_filter_' + $chart_reference + ' .widget-container .list').click(function ($event) {
                        $event.stopPropagation();
                    });

                }

                // If there are groups on the chart
                if ($groupped_first_col) {

                    var $filter_html = '';
                    var $this_chart_reference = $chart_reference + '_cohort';
                    var $label_text = 'View Cohorts';

                    // Go through each dataset and build the list of options
                    $.each($groups, function ($index, $data) {
                        // console.log($index);
                        var $dataset_ref = $this_chart_reference + "_" + $index + "_groups"; // Create a reference based on the chart reference and index
                        var $data_value = $data;

                        $filter_html +=
                            "<li class='table_group_" + $this_chart_reference + "'>" +
                            "<input  type='checkbox' id='filter_" + $dataset_ref + "' data-dataset-index='" + $index + "' data-chart-target='" + $chart_reference + "'  value='" + $data_value + "'/>" +
                            "<label for='filter_" + $dataset_ref + "'><span>" + $data + "</span></label>" +
                            "</li>";
                    });

                    $filter_html = "<div class='chart-filter groups chart_filter_" + $this_chart_reference + "'>" +
                        "<div class='left'>" +
                        "<div class='label'>" + $label_text + "</div>" +
                        "<div class='dropdown widget-container'>" +
                        "<button class='selected'>" +
                        "<span>All</span>" +
                        "</button>" +
                        "<ul class='list'>" + $filter_html + "</ul>" +
                        "</div></div></div>";

                    $container.closest('.chart-container').before($filter_html);

                    // Bind the change action to the filter checkboxes
                    $(".dropdown.widget-container .list li.table_group_" + $this_chart_reference + " input").change(function () {

                        // When a checkbox is ticked go through the list and build the search filter
                        var $value = '';
                        var $chart_target = $(this).data('chart-target');
                        var $selected_groups = [];


                        // // Go through the ticked checkbox and collect the data & Enable the ticked datasets
                        $(this).closest('.dropdown.widget-container').find("input:checked").each(function () {
                            var $raw_value = $(this).val();
                            switch ($raw_value) {
                                case 'Group of Eight (Go8)':
                                    $raw_value = 'Go8';
                                    break;
                                case 'Australian Technology Network (ATN)':
                                    $raw_value = 'ATN';
                                    break;
                                case 'Innovative Research Universities (IRU)':
                                    $raw_value = 'IRU';
                                    break;
                                case 'Regional Universities Network (RUN)':
                                    $raw_value = 'RUN';
                                    break;

                                default:
                                    break;
                            }
                            $value += $raw_value + "|"

                            // Make a list of selected items
                            $selected_groups.push($(this).val())
                        })

                        // console.log('Window chart', window.charts_collection[$chart_reference]);
                        // console.log('Window dataset', window.dataset_collection[$chart_reference]);
                        // console.log('Window labels', window.labels_collection[$chart_reference]);
                        // console.log('Selected groups', $selected_groups);



                        // Reset the chart to it's original state
                        window.charts_collection[$chart_reference].data.labels = window.original_labels[$chart_reference];

                        $(window.charts_collection[$chart_reference].data.datasets).each(function ($index, $data) {
                            window.charts_collection[$chart_reference].data.datasets[$index].data = window.dataset_collection[$chart_reference][$index].data
                        })
                        // window.charts_collection[$chart_reference].data.datasets = window.dataset_collection[$chart_reference];

                        // After collecting all the values check if there is anything to filter
                        if ($value) {
                            // If there a value ticked then we show only the ticked ones
                            $(this).closest('.widget-container').find('.selected span').html($value.slice(0, -1).replace(/\|/g, ", "));
                            // window.charts_collection[$chart_reference].data.labels = window.charts_collection[$chart_reference].data.labels.pop();

                            // Rebuild the list of labels and collect the index 
                            var $list_of_selected_labels_index = [];
                            var $list_of_selected_labels = [];
                            $(window.labels_collection[$chart_reference]).each(function ($label_index, $value) {
                                var $label_group = $value.group;

                                if ($selected_groups.indexOf($label_group) > -1) {
                                    $list_of_selected_labels.push($value.label);
                                    $list_of_selected_labels_index.push($label_index);
                                }
                            });

                            // console.log('$list_of_selected_labels', $list_of_selected_labels);
                            // console.log('$list_of_selected_labels_index', $list_of_selected_labels_index);


                            // Go through each dataset and exclude the ones that are not part of selected labels based on index
                            // var $original_datasets = window.dataset_collection[$chart_reference];
                            var $filtered_dataset = [];

                            $(window.charts_collection[$chart_reference].data.datasets).each(function ($index, $dataset) {
                                var $filtered_data = [];
                                $($dataset.data).each(function ($data_label_index, $data) {
                                    if ($list_of_selected_labels_index.indexOf($data_label_index) > -1) {
                                        $filtered_data.push($data);
                                    }
                                });
                                $dataset['data'] = $filtered_data;
                                $filtered_dataset.push($dataset);
                                // var $filtered_dataset_index = $filtered_dataset.push($dataset);
                                // console.log($filtered_dataset_index -1);
                                // $filtered_dataset[$filtered_dataset_index -1].data = $filtered_data;
                            })

                            // console.log('Filtered dataset', $filtered_dataset);

                            // Update the chart label and dataset
                            window.charts_collection[$chart_reference].data.labels = $list_of_selected_labels;
                            window.charts_collection[$chart_reference].data.datasets = $filtered_dataset;

                        } else {
                            // If no checkbox is ticked then show everything
                            $(this).closest('.widget-container').find('.selected span').html('All');

                        }


                        // Compute the new chart height
                        var $bar_thickness = window.charts_collection[$chart_reference].options.scales.yAxes[0].barThickness;
                        var $number_of_ticks_on_y = window.charts_collection[$chart_reference].data.labels.length;
                        var $chart_height = ($bar_thickness + 45) * $number_of_ticks_on_y;
                        $(this).closest('.chart').find('.chart-container').css('height', $chart_height); // Adjust the canvas height

                        // // Apply to chart
                        window.charts_collection[$chart_reference].resize();
                        window.charts_collection[$chart_reference].update();
                    });

                    // Bind action to expand the filter list
                    $('.chart_filter_' + $this_chart_reference + ' .widget-container button').click(function ($event) {
                        $event.stopPropagation()
                        !$(this).closest('.collapsible-box').hasClass('expanded') ? $(this).closest('.collapsible-box').find('.toggle').click() : '';
                        $(this).siblings('.list').toggleClass('active');
                        $(this).toggleClass('active');
                    })

                    // Clicking on the open filer dropdown. Stop propagation
                    $('.chart_filter_' + $this_chart_reference + ' .widget-container .list').click(function ($event) {
                        $event.stopPropagation();
                    });
                }


            },
            error: function ($err, $file, $inputElem, $reason) {
                console.log('Full error', $err);
                console.log('Error message', $err['message']);
                $container.closest('.chart-container').css('height', 'auto');
                $container.closest('.collapsible-box').addClass('no-data');
                if ($err['message'] === 'Not Found' || $err['message'] === '') {
                    var $textfile = $configuration.url.substr(0, $configuration.url.lastIndexOf("/") + 1) + 'no.chart.footnote.txt'; // remove everything after the last backslash
                    var $error_message = "Data not found";
                    $.ajax({
                        url: $textfile
                    }).done(function ($data) {
                        $data ? $error_message = $data : '';
                        $container.replaceWith("<div class='no-chart not-found'>" + $error_message + "</div>");
                    }).fail(function ($error) {
                        $container.replaceWith("<div class='no-chart not-found'>" + $error_message + "</div>");
                    });
                }
            }
        });
    });

    // Clicking on body to close the filters
    $('body').click(function () {
        $('.widget-container .selected').removeClass('active');
        $('.widget-container .list').removeClass('active');
    })

    $(window).resize(function () {
        if (window.innerWidth < 700) {
            for (var key in window.charts_collection) {
                if (window.charts_collection.hasOwnProperty(key)) {
                    window.charts_collection[key].options.legend.position = "bottom";
                    window.charts_collection[key].options.legend.labels = {
                        boxWidth: 20,
                        padding: 15,
                        fontSize: 13,
                        fontFamily: 'Cabin'
                    };
                }
            }
        }
        if (window.innerWidth > 700) {
            for (var key in window.charts_collection) {
                if (window.charts_collection.hasOwnProperty(key)) {
                    window.charts_collection[key].options.legend.position = "right";
                    window.charts_collection[key].options.legend.labels = {
                        boxWidth: $legend_box_width,
                        padding: $legend_padding,
                        fontSize: $legend_font_size,
                        fontFamily: 'Cabin'
                    };
                }
            }
        }
    });

    function makeid() {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < 5; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }

    function formatLabel(str, maxwidth, $y_axis_leading_zero) {

        if (str && $y_axis_leading_zero && str.toString().length < 4) {
            str = '0' + str.toString();
        }

        if (typeof str === 'string') {
            var sections = [];
            var words = str.split(" ");
            var temp = "";

            words.forEach(function (item, index) {
                if (temp.length > 0) {
                    var concat = temp + ' ' + item;

                    if (concat.length > maxwidth) {
                        sections.push(temp);
                        temp = "";
                    } else {
                        if (index === (words.length - 1)) {
                            sections.push(concat);
                            return;
                        } else {
                            temp = concat;
                            return;
                        }
                    }
                }

                if (index === (words.length - 1)) {
                    sections.push(item);
                    return;
                }

                if (item.length < maxwidth) {
                    temp = item;
                } else {
                    sections.push(item);
                }

            });

            return sections;
        } else {
            return str;
        }
    }

    function colorCodes() {
        var $color_codes = [];
        $color_codes[0] = 'rgba(11,28,42,1)';
        $color_codes[1] = 'rgba(60,123,191,1)';
        $color_codes[2] = 'rgba(96,43,83,1)';
        $color_codes[3] = 'rgba(65,129,108,1)';
        $color_codes[4] = 'rgba(120,80,138,1)';
        $color_codes[5] = 'rgba(0,129,138,1)';
        $color_codes[6] = 'rgba(13,102,108,1)';
        $color_codes[7] = 'rgba(75,65,129,1)';
        $color_codes[8] = 'rgb(15,178,53)';
        $color_codes[9] = 'rgb(172,208,81)';
        $color_codes[10] = 'rgb(32,17,61)';
        $color_codes[11] = 'rgb(118,144,51)';
        $color_codes[12] = 'rgb(66,104,138)';
        $color_codes[13] = 'rgb(245,166,35)';
        $color_codes[14] = 'rgb(67,88,14)';
        $color_codes[15] = 'rgb(147,57,68)';
        $color_codes[16] = 'rgb(201,84,190)';
        $color_codes[17] = 'rgb(121,22,132)';
        $color_codes[18] = 'rgb(98,123,106)';
        $color_codes[19] = 'rgb(80,215,227)';
        $color_codes[20] = 'rgb(154,60,42)';
        $color_codes[21] = 'rgb(58,133,99)';
        $color_codes[22] = 'rgb(139,87,42)';
        $color_codes[23] = 'rgb(86,81,144)';
        $color_codes[24] = 'rgb(126,211,33)';
        $color_codes[25] = 'rgb(224,16,77)';
        $color_codes[26] = 'rgb(144,19,254)';
        $color_codes[27] = 'rgb(194,125,11)';
        $color_codes[28] = 'rgb(173,162,89)';
        $color_codes[29] = 'rgb(133,200,185)';
        $color_codes[30] = 'rgb(53,97,3)';
        return $color_codes;
    }
};

module.exports = Chartblock;
